import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Magic from '@/images/Magic.svg';
import { useAvatarListPageContext } from '@/pages/avatar/ListPage/contex';
import { useTheme } from '@mui/material';

export const GenerateFromText = () => {
    const { setGenerateModalOpen } = useAvatarListPageContext();
    const theme = useTheme();

    return (
        <HeaderButton
            id="generate-avatar-from-text-btn"
            onClick={() => setGenerateModalOpen(true)}
            aria-label="Generate from Text"
            loadingText="Generate from Text"
            color="secondary"
            variant="outlined">
            <MaskedIcon color={theme.colors.black.main} src={Magic} size="24px" />
            Generate from Text
        </HeaderButton>
    );
};
